import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/cart.js";
import "@ui5/webcomponents-icons/dist/money-bills.js";
import "@ui5/webcomponents-icons/dist/bar-code.js";
import "@ui5/webcomponents-icons/dist/product.js";
import "@ui5/webcomponents-icons/dist/line-chart.js";
import "@ui5/webcomponents-icons/dist/wallet.js";
import "@ui5/webcomponents-icons/dist/factory.js";
import "@ui5/webcomponents-icons/dist/payment-approval.js";
import "@ui5/webcomponents-icons/dist/business-objects-experience.js";
import "@ui5/webcomponents-icons/dist/settings.js";

import { jewelPermissions as p, jewelSettingsGroup } from "./permissions";

/** Jewellery entries of the navigation registry (group `jewel`, docs/contracts/jewellery.md). */
export const jewelNavigation: readonly NavigationEntry[] = [
  { key: "jewel.sales", labelKey: "nav.jewelSales", icon: "cart", path: "/jewel/sales", permission: p.saleView },
  {
    key: "jewel.buyBacks",
    labelKey: "nav.jewelBuyBacks",
    icon: "money-bills",
    path: "/jewel/buybacks",
    permission: p.buyBackView,
  },
  { key: "jewel.tags", labelKey: "nav.jewelTags", icon: "bar-code", path: "/jewel/tags", permission: p.tagView },
  {
    key: "jewel.accounts",
    labelKey: "nav.jewelAccounts",
    icon: "wallet",
    path: "/jewel/gold-accounts",
    permission: p.accountView,
  },
  {
    key: "jewel.refining",
    labelKey: "nav.jewelRefining",
    icon: "factory",
    path: "/jewel/refining",
    permission: p.refiningView,
  },
  {
    key: "jewel.wages",
    labelKey: "nav.jewelWages",
    icon: "payment-approval",
    path: "/jewel/wages",
    permission: p.wagesView,
  },
  {
    key: "jewel.reports",
    labelKey: "nav.jewelReports",
    icon: "business-objects-experience",
    path: "/jewel/reports",
    permission: p.reportView,
  },
  {
    key: "jewel.prices",
    labelKey: "nav.jewelPrices",
    icon: "line-chart",
    path: "/jewel/prices",
    permission: p.priceView,
  },
  {
    key: "jewel.items",
    subGroup: "setup",
    labelKey: "nav.jewelItems",
    icon: "product",
    path: "/jewel/items",
    permission: p.itemView,
  },
  {
    key: "jewel.settings",
    subGroup: "setup",
    labelKey: "nav.jewelSettings",
    icon: "settings",
    path: `/platform/settings/${jewelSettingsGroup}`,
    permission: p.settingsView,
  },
];
